export default "__VITE_ASSET__BiYU5umH__"